import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-web-ingestion-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './web-ingestion-modal.html',
  styleUrl: './web-ingestion-modal.scss',
})
export class WebIngestionModal {
  @Input() indexName: string = '';
  urlToCrawl: string = '';
  activeModal = inject(NgbActiveModal);

  confirm() {
    if (!this.urlToCrawl) return;
    this.activeModal.close(this.urlToCrawl);
  }
}